module.exports = __webpack_public_path__ + "static/media/profile-card-sm.1e9d4e64.png";